import { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import '../../styles/login.scss';

import logo from '../../assets/images/GOVT_LOGO.png';
import illustration from '../../assets/images/loginDesign1.png';
import emisLogo from '../../assets/images/emis_logo_1.png';
import gwigLogo from '../../assets/images/gwig.png';
import wcLogo from '../../assets/images/wc.jpeg';
import {
  useEmisLoginMutation,
  useLazyGetEmisReactDetailsQuery,
} from './Login.service';
import { useLazyGetMenuOptionsQuery } from '../../layouts/Navbar/Navbar.service';
import { useNavigate } from 'react-router-dom';
import { useUI } from '../../shared/UI/Uicontext';
import {
  useForgotPasswordOtpMutation,
  useResetPassOtpSubmitMutation,
  useForgotPassUpdateMutation,
} from './Login.service';

import { alertService } from 'shared/services/alertService';
import { decryptData, DecryptedResponse } from 'shared/services/cryptoService';
import { AppDispatch } from '../../store';
import { useDispatch } from 'react-redux';
import { loadSession, clearSession } from '../../store/slices/sessionSlice';
import { decodeSessionFromStorage } from '../../shared/services/userSessionService';
import { primeAngularSession } from '../../shared/services/sessionBridge';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

export default function Login() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { showLoader, hideLoader, showSuccess, showError } = useUI();

  // When user lands on login page, clear any stale session data
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      // Stale token exists — clear everything so login starts fresh
      localStorage.clear();
      dispatch(clearSession());
    }
  }, [dispatch]);
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [isShow, setIsShow] = useState(true);
  const [userNameTouched, setUserNameTouched] = useState(false);
  const [passwordTouched, setPasswordTouched] = useState(false);
  const [contactUs, setContactUs] = useState(false);
  const [showBrowsers, setShowBrowsers] = useState(false);
  const [modalHeader, setModalHeader] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const baseUrl = 'DOF-' + process.env.REACT_APP_API_apiBaseUrl + '-AuthData';
  const [showGrievance, setShowGrievance] = useState(false);
  const [showMandatoryToast, setShowMandatoryToast] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [mobileNumber, setMobileNumber] = useState('');
  const [forgotUserNameError, setForgotUserNameError] = useState('');
  const [forgotUserNameTouched, setForgotUserNameTouched] = useState(false);
  const [validation, setValidation] = useState(true);
  const [staffDetails, setStaffDetails] = useState({
    name: '',
    phone_number: '',
    dob: '',
    gender: '',
    address: '',
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [touched, setTouched] = useState<Record<string, boolean>>({});
  const [submitted, setSubmitted] = useState(false);

  const [otpMsg, setOtpMsg] = useState('');
  const [otpConfirmation, setOtpConfirmation] = useState(false);

  const [otpValue, setOtpValue] = useState('');
  const [showPass, setShowPass] = useState(false);

  const [newPassValue, setNewPassValue] = useState('');
  const [confirmPassValue, setConfirmPassValue] = useState('');

  const [isConShow, setIsConShow] = useState(true);
  const [otpDialog, setOtpDialog] = useState(false);
  const [otpSubmissionDialog, setOtpSubmissionDialog] = useState(false);

  const [forgotPasswordOtp] = useForgotPasswordOtpMutation();

  const [showResetPasswordDialog, setShowResetPasswordDialog] = useState(false);

  const [forgotPassUpdate] = useForgotPassUpdateMutation();
  const [resetPassOtpSubmit] = useResetPassOtpSubmitMutation();

  const [emisLogin] = useEmisLoginMutation();
  const [getEmisReactDetails] = useLazyGetEmisReactDetailsQuery();
  const [getMenuOptions] = useLazyGetMenuOptionsQuery();
  const currentYear = new Date().getFullYear();
  const minDob = `${currentYear - 65}-01-01`;
  const maxDob = `${currentYear - 16}-01-01`;
  const s = useSelector((state: RootState) => state.session);
  const validateForm = (data: typeof staffDetails) => {
    const errs: Record<string, string> = {};
    if (!data.name || data.name.trim() === '') errs.name = 'Name is required';
    if (!data.phone_number || data.phone_number.trim() === '') {
      errs.phone_number = 'Phone No is required';
    } else if (!/^[6-9]\d{9}$/.test(data.phone_number)) {
      errs.phone_number = 'It is not a valid mobile number.';
    }
    if (!data.dob) errs.dob = 'DOB is required';
    if (!data.gender) errs.gender = 'Select gender';
    if (!data.address || data.address.trim() === '')
      errs.address = 'Address is required';
    return errs;
  };

  const checkSameNum = (num: string) => {
    const arr = num.split('');
    return arr.every((el) => el === arr[0]);
  };

  const numberOnly = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!/[0-9]/.test(e.key) && e.key !== 'Backspace') e.preventDefault();
  };

  const handleNameChange = (value: string) => {
    if (/ {2}/.test(value)) {
      setStaffDetails((prev) => ({ ...prev, name: value.slice(0, -1) }));
      return;
    }
    setStaffDetails((prev) => ({ ...prev, name: value.toUpperCase() }));
  };

  const handleMobileChange = (value: string) => {
    setStaffDetails((prev) => ({ ...prev, phone_number: value }));
    if (value.length === 10 && checkSameNum(value)) {
      setStaffDetails((prev) => ({ ...prev, phone_number: '' }));
    }
  };

  const handleBlur = (field: keyof typeof staffDetails) => {
    setTouched((prev) => ({ ...prev, [field]: true }));
    const errs = validateForm(staffDetails);
    setErrors((prev) => ({ ...prev, [field]: errs[field] || '' }));
  };

  const showGrievanceDtl = () => {
    setShowGrievance(true);
    setSubmitted(false);
    setTouched({});
    setErrors({});
    setStaffDetails({
      name: '',
      phone_number: '',
      dob: '',
      gender: '',
      address: '',
    });
  };

  const handleSendOTP = () => {
    setSubmitted(true);
    setTouched({
      name: true,
      phone_number: true,
      dob: true,
      gender: true,
      address: true,
    });
    const errs = validateForm(staffDetails);
    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      setShowMandatoryToast(true);
      setTimeout(() => setShowMandatoryToast(false), 3000);
      return;
    }
    console.log('Send OTP payload:', staffDetails);
    setShowGrievance(false);
  };

  const isUserNameInvalid = userNameTouched && userName.trim() === '';
  const isPasswordInvalid = passwordTouched && password.trim() === '';

  const eyeClick = () => setIsShow((prev) => !prev);

  const handleLogin = async () => {
    setUserNameTouched(true);
    setPasswordTouched(true);
    if (userName.trim() === '' || password.trim() === '') return;

    showLoader();

    const payload = {
      records: {
        emis_username: userName,
        emis_password: password,
      },
    };

    try {
      const result = await emisLogin(payload).unwrap();
      console.log('Login success:', result);
      if (result.dataStatus) {
        localStorage.setItem('token', result.records.token);
        localStorage.setItem(baseUrl, result.records.token);

        const session = decodeSessionFromStorage();

        if (!session) {
          hideLoader();
          showError('Session details not found');
          return;
        }

        dispatch(loadSession(session));

        // Prime the Angular EMIS session over the cross-origin bridge
        // (fire-and-forget; never blocks login).
        primeAngularSession().catch((err) => {
          console.warn('Angular session sync failed (non-blocking):', err);
        });

        // 1) Fetch the app menu JSON first so it's cached in localStorage
        // before the navbar mounts. Non-fatal: if it fails, the navbar still
        // fetches it on mount as a fallback, so login should not be blocked.
        try {
          await getMenuOptions().unwrap();
          console.log('json fetched');
        } catch (menuErr) {
          console.warn('Menu options fetch failed (non-blocking):', menuErr);
        }

        // 2) Then fetch EmisReactDetails (the menu-visibility context).
        const emisReactDetails = await getEmisReactDetails({
          userName: userName,
        }).unwrap();

        console.log(emisReactDetails, 'emisReactDetails');

        localStorage.setItem(
          'emisReactDetails',
          JSON.stringify(emisReactDetails.records)
        );
        localStorage.setItem(
          'allotedCheck',
          JSON.stringify(emisReactDetails.localStorageParms.allotedCheck)
        );
        showSuccess('Login successful');
        navigate('/dashboard');
      } else {
        showError(result.message);
      }
      // dispatch loadSession(result) here

      hideLoader();
    } catch (error) {
      console.error('Login failed:', error);
      hideLoader();
      showError('Invalid credentials'); // show error to user
    }
  };

  const handleContact = (type: number) => {
    setContactUs(true);
    if (type === 1) {
      setModalHeader('Compatible Browsers');
      setShowBrowsers(true);
    } else {
      setModalHeader('CONTACT US');
      setShowBrowsers(false);
    }
  };

  const handleCloseContact = () => {
    setContactUs(false);
    setShowBrowsers(false);
  };

  const handlePrivacyPolicy = () => {
    window.open('/auth/privacy_policy', '_blank');
  };

  const handleEGovernment = () => {
    window.open('/auth/eGovernment/IT', '_blank');
  };

  const downloadMyFile = async () => {
    const fileName = 'EMIS_TN_Sheet.pdf';
    const bucketName = 'renewalapplicationemis';
    const expiry = 1800;

    if (!fileName) {
      alert('No files are Found');
      return;
    }

    try {
      setDownloading(true);
      const params = new URLSearchParams({
        bcktId: bucketName,
        filename: fileName,
        expiry: String(expiry),
      });
      const response = await fetch(
        `https://d8omnqcdi1.execute-api.ap-south-1.amazonaws.com/staging-resource-collection-mgmt/resource-collection-mgmt/resource-listurl?${params}`
      );
      const res = await response.json();
      if (res && res.url) {
        window.open(res.url, '_blank');
      } else {
        alert('No files are Found');
      }
    } catch {
      alert('No files are Found');
    } finally {
      setDownloading(false);
    }
  };

  const [showForgotForm, setShowForgotForm] = useState(false);

  const [userType, setUserType] = useState('');
  const [forgotUserName, setForgotUserName] = useState('');

  const userTypes = [
    { value: 'school', label: 'School' },
    { value: 'teacher', label: 'Teacher' },
  ];

  const handleRequestOtp = async () => {
    if (!userType) {
      showError('Please select user type');
      return;
    }

    const error = validateForgotUsername(forgotUserName.trim(), userType);
    setForgotUserNameError(error);
    if (error) return;

    try {
      const payload = {
        userId: forgotUserName.trim(),
        userType: userType === 'school' ? 1 : 14,
        triggered_by_username: forgotUserName.trim(),
        triggered_by_usertype: userType === 'school' ? 1 : 14,
        triggered_for_username: forgotUserName.trim(),
        triggered_for_usertype: userType === 'school' ? 1 : 14,
      };

      const response = await forgotPasswordOtp(payload).unwrap();
      console.log('Raw OTP API response:', response);

      let decryptedResponse: any;
      try {
        decryptedResponse = decryptData<any>(response);
        console.log('Decrypted OTP response:', decryptedResponse);
      } catch (decryptErr) {
        console.error('Decryption failed:', decryptErr);
        showError('Failed to send OTP (decryption error)');
        return;
      }

      // ✅ Explicit dataStatus check
      if (!decryptedResponse?.dataStatus) {
        showError(decryptedResponse?.message || 'Failed to send OTP');
        return;
      }

      const mobileNo =
        decryptedResponse?.result?.[0]?.target_mobile_number || '';

      setMobileNumber(mobileNo);
      setOtpMsg(
        `OTP has been successfully sent to your mobile number - ${mobileNo}. Please enter the OTP within 3 days to reset the password.`
      );
      setOtpDialog(true); // dialog only opens on real success now
    } catch (error) {
      console.error('OTP request failed:', error);
      showError('Failed to send OTP');
    }
  };

  const maskMobileNumber = (mobile: string) => {
    if (!mobile || mobile.length < 10) return mobile;

    return `XXXXX X${mobile.slice(-4)}`;
  };

  const handleOtpSubmit = async () => {
    if (!otpValue.trim()) {
      alertService.warning('Please enter OTP');
      return;
    }

    if (otpValue.length !== 6) {
      alertService.warning('OTP must be 6 digits');
      return;
    }

    try {
      const payload = {
        triggered_by_username: forgotUserName,
        triggered_by_usertype: userType === 'school' ? 1 : 14,
        otp_purpose_id: 7,
        otp: otpValue,
      };

      const response = await resetPassOtpSubmit(payload).unwrap();
      console.log('Raw OTP Submit response:', response);

      let decryptedResponse: any;
      try {
        decryptedResponse = decryptData<any>(response);
        console.log('Decrypted OTP Submit response:', decryptedResponse);
      } catch (decryptErr) {
        console.error('Decryption failed:', decryptErr);
        alertService.error('OTP verification failed');
        return;
      }

      // ✅ Only proceed if the OTP was actually valid
      // inside handleOtpSubmit, in the success branch
      if (!decryptedResponse?.dataStatus) {
        alertService.error(decryptedResponse?.message || 'Invalid OTP');
        return;
      }

      // Clear any stale password values before showing the popup
      setNewPassValue('');
      setConfirmPassValue('');
      setShowNewPassword(false);
      setShowConfirmPassword(false);

      setOtpSubmissionDialog(false);
      setShowResetPasswordDialog(true);
    } catch (error) {
      console.error('OTP Error:', error);
      alertService.error('OTP verification failed');
    }
  };

  const handlePasswordSubmit = async () => {
    if (!newPassValue.trim()) {
      alertService.warning('Please enter new password');
      return;
    }

    if (!confirmPassValue.trim()) {
      alertService.warning('Please enter confirm password');
      return;
    }

    // At least one lowercase, one uppercase, one digit, 8–15 chars total
    const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,15}$/;

    if (!passwordPattern.test(newPassValue)) {
      alertService.warning(
        'Password must be 8-15 characters and include at least one uppercase letter, one lowercase letter, and one number'
      );
      return;
    }

    if (newPassValue !== confirmPassValue) {
      alertService.warning('Passwords do not match');
      return;
    }

    try {
      const payload = {
        username: forgotUserName,
        usertype: userType === 'school' ? 1 : 14,
        password: newPassValue,
        confirm_password: confirmPassValue,
      };

      const response = await forgotPassUpdate(payload).unwrap();
      console.log('Password Update Response:', response);

      alertService.success('Password updated successfully');

      setShowResetPasswordDialog(false);
      setOtpSubmissionDialog(false);
      setShowForgotForm(false);

      setOtpValue('');
      setNewPassValue('');
      setConfirmPassValue('');
    } catch (error) {
      console.error(error);
      alertService.error('Failed to update password');
    }
  };
  const handleOtpSuccessOk = () => {
    setOtpDialog(false);
    setOtpSubmissionDialog(true);
  };

  const validateForgotUsername = (username: string, userType: string) => {
    if (userType === 'teacher' && username.length !== 8) {
      return 'Invalid Pattern Limit 8 digits';
    }

    if (userType === 'school' && username.length !== 11) {
      return 'Invalid Pattern Limit 11 digits';
    }

    return '';
  };

  const resetForgotPasswordForm = () => {
    setUserType('');
    setForgotUserName('');
    setForgotUserNameError('');
    setForgotUserNameTouched(false);

    setOtpValue('');
    setMobileNumber('');

    setOtpDialog(false);
    setOtpSubmissionDialog(false);
    setShowResetPasswordDialog(false);

    setNewPassValue('');
    setConfirmPassValue('');
  };

  const handleUserTypeChange = (value: string) => {
    setUserType(value);
    setForgotUserName('');
    setForgotUserNameError('');
    setForgotUserNameTouched(false);
  };
  return (
    <div className="login-page">
      {/* ── Card ── */}
      <div className="card login-card">
        {/* Full-card background image */}
        <div className="card-bg">
          <img src={illustration} alt="" />
        </div>

        {/* Content row — sits on top of background */}
        <div className="row g-0 card-row">
          {/* Left half — transparent, shows background image */}
          <div className="col-md-6" />

          {/* Right half — form content */}
          <div className="col-md-6 form-col d-flex align-items-center">
            <div className="auth-form-wrapper px-4 py-4 w-100">
              <div className="tn-logo text-center mb-3">
                <img src={logo} alt="TN Govt Logo" />
              </div>

              <span className="nobleui-logo d-block mb-4 text-center">
                Educational Management Information System
              </span>

              {!showForgotForm ? (
                <>
                  {/* Login Form */}
                  <div className="mb-3">
                    <label className="form-label">
                      User Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="User Name"
                      value={userName}
                      onChange={(e) => setUserName(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">
                      Password <span className="text-danger">*</span>
                    </label>

                    <div className="position-relative">
                      <input
                        type={isShow ? 'password' : 'text'}
                        className="form-control"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />

                      <i
                        className={isShow ? 'pi pi-eye' : 'pi pi-eye-slash'}
                        onClick={eyeClick}
                        style={{
                          position: 'absolute',
                          right: '12px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer',
                        }}
                      />
                    </div>
                  </div>

                  <div className="text-center mt-3">
                    <Button
                      label="Login"
                      className="login-btn me-2"
                      onClick={handleLogin}
                    />

                    <Button
                      label="Forgot Password"
                      className="forgot-btn"
                      onClick={() => {
                        resetForgotPasswordForm();
                        setShowForgotForm(true);
                      }}
                    />
                  </div>
                </>
              ) : (
                <>
                  {/* Forgot Password Form */}

                  <div className="mb-3">
                    <label className="form-label">
                      Please Select Your User Type{' '}
                      <span className="text-danger">*</span>
                    </label>

                    <select
                      className="form-select"
                      value={userType}
                      onChange={(e) => handleUserTypeChange(e.target.value)}
                    >
                      <option value="" disabled>
                        User Type
                      </option>

                      <option value="school">School</option>
                      <option value="teacher">Teacher</option>
                    </select>
                  </div>

                  {userType && (
                    <>
                      <div className="mb-3">
                        <label className="form-label">
                          User Name <span className="text-danger">*</span>
                        </label>

                        <input
                          type="text"
                          className={`form-control ${
                            forgotUserNameTouched && forgotUserNameError
                              ? 'is-invalid'
                              : ''
                          }`}
                          placeholder="Enter User Name"
                          value={forgotUserName}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '');

                            setForgotUserName(value);

                            if (forgotUserNameTouched) {
                              setForgotUserNameError(
                                validateForgotUsername(value, userType)
                              );
                            }
                          }}
                          onBlur={() => {
                            setForgotUserNameTouched(true);
                            setForgotUserNameError(
                              validateForgotUsername(forgotUserName, userType)
                            );
                          }}
                        />

                        {forgotUserNameTouched && forgotUserNameError && (
                          <div className="text-danger mt-1">
                            {forgotUserNameError}
                          </div>
                        )}
                      </div>

                      <div className="d-flex justify-content-center gap-2">
                        <button
                          className="btn btn-primary"
                          onClick={handleRequestOtp}
                        >
                          Request OTP
                        </button>

                        <button
                          className="btn btn-primary"
                          onClick={handleOtpSubmit}
                        >
                          OTP Submit
                        </button>

                        <button
                          className="btn btn-primary"
                          onClick={() => {
                            resetForgotPasswordForm();
                            setShowForgotForm(false);
                          }}
                        >
                          Back To Login
                        </button>
                      </div>
                    </>
                  )}
                </>
              )}

              <div className="mt-3 text-center">
                <i className="pi pi-envelope me-1"></i>
                <a href="mailto:enquire.tnemis@gmail.com">
                  enquire.tnemis@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Footer Wrapper ── */}
      <div className="footer-wrapper">
        {/* Footer 1 */}
        <div className="login-footer1">
          <div className="content text-center px-3 py-2">
            <div className="footer-links-row">
              <a
                href="https://tnschools.gov.in/"
                target="_blank"
                rel="noreferrer"
              >
                About us
              </a>{' '}
              ||&nbsp;
              <span
                className="text-primary"
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={showGrievanceDtl}
              >
                Grievances/Complaints
              </span>{' '}
              ||&nbsp;
              <a
                href="https://cmhelpline.tnega.org/portal/en/home"
                target="_blank"
                rel="noreferrer"
              >
                Mudhalvarin Mugavari
              </a>{' '}
              ||&nbsp;
              <a
                href="http://cca.gov.in/index.php"
                target="_blank"
                rel="noreferrer"
              >
                How to avail Electronic/Digital Signature facility
              </a>
              ||&nbsp;
              <a onClick={handlePrivacyPolicy}>Privacy Policy</a> ||&nbsp;
              <a
                href="https://www.tn.gov.in/documents/dept/17"
                target="_blank"
                rel="noreferrer"
              >
                Cyber Resilence
              </a>{' '}
              ||&nbsp;
              <a onClick={handleEGovernment} style={{ cursor: 'pointer' }}>
                About TN School Education Department
              </a>
            </div>

            <p className="focus-link mb-1">
              <a
                className="text-primary"
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
                onClick={() => handleContact(1)}
              >
                Compatible Browsers
              </a>{' '}
              ||{' '}
              <a
                className="text-primary"
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
                onClick={() => handleContact(2)}
              >
                CONTACT US
              </a>{' '}
              ||&nbsp;
              <strong>E-mail: </strong>
              <a href="mailto:enquire.tnemis@gmail.com">
                enquire.tnemis@gmail.com
              </a>
              ||&nbsp;
              <strong>Last Update :</strong> 20-05-2026 ||&nbsp;
              <strong>Visitors Count :</strong> 179766363
            </p>

            <div className="badge-row mb-2">
              <img src={wcLogo} alt="W3C" className="footer-badge wc-img" />

              <img
                src={gwigLogo}
                alt="Government Websites"
                className="footer-badge gwig-img"
              />
            </div>
          </div>
        </div>

        {/* Footer 2 */}
        <div className="login-footer2">
          <div className="row align-items-center text-center w-100 m-0">
            <div className="col-md-2 col-sm-12 mt-1">
              <div className="sub-footer-data">
                <img
                  src={emisLogo}
                  alt="EMIS Footer Logo"
                  className="img-fluid emis-footer-logo"
                  style={{
                    height: '37px',
                    width: '205.262px',
                    maxWidth: '100%',
                    display: 'inline',
                    verticalAlign: 'middle',
                  }}
                />
              </div>
            </div>

            <div className="col-md-7 col-sm-12 mt-1">
              <p
                className="copy"
                style={{
                  fontSize: '13px',
                  fontWeight: 400,
                  lineHeight: '19.5px',
                  color: 'rgb(255,255,255)',
                  textAlign: 'center',
                  marginBottom: '16px',
                  marginTop: 0,
                }}
              >
                Copyright ©2023 This is the official website of EMIS, School
                Education Department, Government of Tamil Nadu, India All Rights
                Reserved.
              </p>
            </div>

            <div className="col-md-1 col-sm-12 mt-1">
              <a
                href="https://www.facebook.com/EMIS-Tamilnadu-Info-788395421347426/"
                target="_blank"
                rel="noreferrer"
                className="social-link"
              >
                <i className="pi pi-facebook" />
              </a>

              <a
                href="https://twitter.com/emis_tamilnadu"
                target="_blank"
                rel="noreferrer"
                className="social-link ms-2"
              >
                <i className="pi pi-twitter" />
              </a>
            </div>

            <div className="col-md-2 col-sm-12 my-2">
              <div
                className="float-right text-center"
                style={{
                  display: 'block',
                  fontSize: '13px',
                  fontWeight: 400,
                  height: '35px',
                  lineHeight: '19.5px',
                  textAlign: 'center',
                  color: 'rgb(255,255,255)',
                }}
              >
                <button
                  type="button"
                  onClick={downloadMyFile}
                  disabled={downloading}
                  style={{
                    alignItems: 'center',
                    backgroundColor: 'rgb(255,255,255)',
                    border: '0.8px solid rgb(231,24,104)',
                    borderRadius: '6px',
                    boxShadow: 'none',
                    boxSizing: 'border-box',
                    color: 'rgb(231,24,104)',
                    cursor: downloading ? 'not-allowed' : 'pointer',
                    display: 'inline-flex',
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                    fontSize: '12px',
                    fontWeight: 400,
                    height: '35px',
                    lineHeight: '18px',
                    overflow: 'hidden',
                    padding: '7.2px 16px',
                    position: 'relative',
                    textAlign: 'center',
                    transition:
                      'background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease',
                    verticalAlign: 'bottom',
                  }}
                >
                  <span
                    style={{
                      color: 'rgb(231,24,104)',
                      display: 'block',
                      flex: '1 1 auto',
                      fontSize: '12px',
                      fontWeight: 700,
                      height: '18px',
                      lineHeight: '18px',
                      textAlign: 'center',
                    }}
                  >
                    {downloading ? 'Downloading...' : 'Download Forms'}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Contact / Compatible Browsers Modal ── */}
      {contactUs && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
        >
          <div
            style={{
              width: '90%',
              maxWidth: '1100px',
              maxHeight: '90%',
              borderRadius: '6px',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              boxShadow: 'rgba(0,0,0,0.3) 0px 1px 3px 0px',
              fontFamily:
                '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: '24px',
              color: 'rgb(33,37,41)',
            }}
          >
            {/* Pink header bar */}
            <div
              style={{
                background: '#e91e63',
                padding: '14px 20px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <span
                style={{ color: '#fff', fontWeight: 700, fontSize: '18px' }}
              >
                {modalHeader}
              </span>
              <button
                onClick={handleCloseContact}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: '#fff',
                  fontSize: '20px',
                  cursor: 'pointer',
                  lineHeight: 1,
                }}
              >
                ×
              </button>
            </div>

            {/* White body */}
            <div
              style={{
                background: '#fff',
                padding: '30px 30px 20px',
                minHeight: '200px',
              }}
            >
              {showBrowsers && (
                <div style={{ marginLeft: '35%' }}>
                  <h2
                    style={{
                      fontSize: '32px',
                      fontWeight: 500,
                      color: 'rgb(73,80,87)',
                      lineHeight: '38.4px',
                      marginTop: 0,
                      marginBottom: '8px',
                    }}
                  >
                    Compatible Browsers
                  </h2>
                  <ul style={{ listStyle: 'disc', paddingLeft: '20px' }}>
                    <li>Mozilla Firefox 46 and above</li>
                    <li>Google Chrome 45 and above</li>
                    <li>Edge 13 and above</li>
                    <li>Safari 10 and above</li>
                  </ul>
                </div>
              )}

              {!showBrowsers && (
                <div
                  style={{
                    marginLeft: '35%',
                    fontSize: '16px',
                    lineHeight: '24px',
                    color: 'rgb(33,37,41)',
                  }}
                >
                  <p style={{ margin: 0 }}>Samagra Shiksha,</p>
                  <p style={{ margin: 0 }}>DPI Campus, College Road,</p>
                  <p style={{ margin: 0 }}>
                    Nungambakkam, Chennai - 600 006, Tamil Nadu.
                  </p>
                  <p style={{ margin: 0 }}>
                    <strong>Phone Number: 044- 29994215</strong>
                  </p>
                  <p style={{ margin: 0 }}>
                    <strong>Email: enquire.tnemis@gmail.com</strong>
                  </p>
                </div>
              )}

              <div style={{ textAlign: 'right', marginTop: '30px' }}>
                <button
                  onClick={handleCloseContact}
                  style={{
                    backgroundColor: '#f0ad4e',
                    border: 'none',
                    padding: '8px 20px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    color: '#fff',
                    fontWeight: 500,
                    fontSize: '15px',
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Mandatory fields toast */}
      {showMandatoryToast && (
        <div
          style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            zIndex: 9999,
            backgroundColor: '#dc3545',
            color: '#fff',
            padding: '12px 18px',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '14px',
            fontWeight: 500,
            boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
          }}
        >
          <span style={{ fontSize: '18px', lineHeight: 1 }}>&#x2297;</span>
          Please fill all mandatory fields
        </div>
      )}

      {/* ── Grievances/Complaints Modal ── */}
      {showGrievance && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: '#fff',
              borderRadius: '6px',
              boxShadow: 'rgba(0,0,0,0.3) 0px 1px 3px 0px',
              overflow: 'hidden',
              width: '90%',
              maxWidth: '1100px',
              maxHeight: '90%',
              display: 'flex',
              flexDirection: 'column',
              fontFamily:
                '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: '24px',
              color: 'rgb(33,37,41)',
              position: 'relative',
            }}
          >
            {/* Header */}
            <div
              style={{
                background: '#e91e63',
                color: '#fff',
                padding: '15px 20px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <span
                style={{
                  fontSize: '20px',
                  fontWeight: 700,
                  lineHeight: '30px',
                  height: '30px',
                  color: '#fff',
                  display: 'block',
                }}
              >
                Retired Staff Grievance Registration
              </span>
              <span
                style={{
                  cursor: 'pointer',
                  fontSize: '22px',
                  lineHeight: 1,
                  fontWeight: 300,
                }}
                onClick={() => setShowGrievance(false)}
              >
                &times;
              </span>
            </div>

            {/* Body */}
            <div style={{ padding: '20px' }}>
              <button
                onClick={() => setShowGrievance(false)}
                style={{
                  backgroundColor: '#e53935',
                  color: '#fff',
                  border: 'none',
                  padding: '8px 20px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  marginBottom: '20px',
                }}
              >
                Back
              </button>

              {/* Row 1: Name | Phone | DOB */}
              <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                <div style={{ flex: 1, minWidth: '200px' }}>
                  <label
                    style={{
                      fontWeight: 500,
                      marginBottom: '5px',
                      display: 'block',
                    }}
                  >
                    Staff Name <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter staff name"
                    value={staffDetails.name}
                    maxLength={50}
                    onKeyDown={(e) => {
                      if (e.key.length === 1 && !/[a-zA-Z\s\-']/.test(e.key))
                        e.preventDefault();
                    }}
                    onChange={(e) => handleNameChange(e.target.value)}
                    onBlur={() => handleBlur('name')}
                  />
                  {(touched.name || submitted) && errors.name && (
                    <span
                      style={{
                        color: 'red',
                        fontSize: '12px',
                        marginTop: '4px',
                        display: 'block',
                      }}
                    >
                      {errors.name}
                    </span>
                  )}
                </div>

                <div style={{ flex: 1, minWidth: '200px' }}>
                  <label
                    style={{
                      fontWeight: 500,
                      marginBottom: '5px',
                      display: 'block',
                    }}
                  >
                    Phone No <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter phone number"
                    value={staffDetails.phone_number}
                    maxLength={10}
                    onKeyDown={numberOnly}
                    onChange={(e) => handleMobileChange(e.target.value)}
                    onBlur={() => handleBlur('phone_number')}
                  />
                  {(touched.phone_number || submitted) &&
                    errors.phone_number && (
                      <span
                        style={{
                          color: 'red',
                          fontSize: '12px',
                          marginTop: '4px',
                          display: 'block',
                        }}
                      >
                        {errors.phone_number}
                      </span>
                    )}
                </div>

                <div style={{ flex: 1, minWidth: '200px' }}>
                  <label
                    style={{
                      fontWeight: 500,
                      marginBottom: '5px',
                      display: 'block',
                    }}
                  >
                    Date Of Birth <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    min={minDob}
                    max={maxDob}
                    value={staffDetails.dob}
                    onChange={(e) =>
                      setStaffDetails((prev) => ({
                        ...prev,
                        dob: e.target.value,
                      }))
                    }
                    onBlur={() => handleBlur('dob')}
                  />
                  {(touched.dob || submitted) && errors.dob && (
                    <span
                      style={{
                        color: 'red',
                        fontSize: '12px',
                        marginTop: '4px',
                        display: 'block',
                      }}
                    >
                      {errors.dob}
                    </span>
                  )}
                </div>
              </div>

              {/* Row 2: Gender | Address */}
              <div
                style={{
                  display: 'flex',
                  gap: '15px',
                  flexWrap: 'wrap',
                  marginTop: '15px',
                }}
              >
                <div style={{ flex: 1, minWidth: '200px' }}>
                  <label
                    style={{
                      fontWeight: 500,
                      marginBottom: '5px',
                      display: 'block',
                    }}
                  >
                    Gender <span style={{ color: 'red' }}>*</span>
                  </label>
                  <select
                    className="form-control"
                    value={staffDetails.gender}
                    onChange={(e) =>
                      setStaffDetails((prev) => ({
                        ...prev,
                        gender: e.target.value,
                      }))
                    }
                    onBlur={() => handleBlur('gender')}
                  >
                    <option value="">Please select gender</option>
                    <option value="1">Male</option>
                    <option value="2">Female</option>
                    <option value="3">Transgender</option>
                  </select>
                  {(touched.gender || submitted) && errors.gender && (
                    <span
                      style={{
                        color: 'red',
                        fontSize: '12px',
                        marginTop: '4px',
                        display: 'block',
                      }}
                    >
                      {errors.gender}
                    </span>
                  )}
                </div>

                <div style={{ flex: 1, minWidth: '200px' }}>
                  <label
                    style={{
                      fontWeight: 500,
                      marginBottom: '5px',
                      display: 'block',
                    }}
                  >
                    Address <span style={{ color: 'red' }}>*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows={2}
                    placeholder="Enter address"
                    value={staffDetails.address}
                    onChange={(e) =>
                      setStaffDetails((prev) => ({
                        ...prev,
                        address: e.target.value,
                      }))
                    }
                    onBlur={() => handleBlur('address')}
                  />
                  {(touched.address || submitted) && errors.address && (
                    <span
                      style={{
                        color: 'red',
                        fontSize: '12px',
                        marginTop: '4px',
                        display: 'block',
                      }}
                    >
                      {errors.address}
                    </span>
                  )}
                </div>

                {/* Empty spacer — aligns with Date Of Birth column above */}
                <div style={{ flex: 1, minWidth: '200px' }} />
              </div>

              {/* Buttons */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '10px',
                  marginTop: '20px',
                }}
              >
                <button
                  onClick={handleSendOTP}
                  style={{
                    backgroundColor: '#4caf50',
                    color: '#fff',
                    border: 'none',
                    padding: '10px 24px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                  }}
                >
                  Send OTP
                </button>
                <button
                  onClick={() => setShowGrievance(false)}
                  style={{
                    backgroundColor: '#e53935',
                    color: '#fff',
                    border: 'none',
                    padding: '10px 24px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {otpDialog && (
        <>
          {/* Overlay */}
          <div className="modal-backdrop fade show" style={{ zIndex: 9999 }} />

          {/* Modal Dialog */}
          <div
            className="modal fade show d-block"
            style={{ zIndex: 10000 }}
            tabIndex={-1}
          >
            <div
              className="modal-dialog modal-dialog-centered"
              style={{ maxWidth: '1020px' }}
            >
              {/* p dialogue styles */}
              <div
                className="modal-content"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  pointerEvents: 'auto',
                  maxHeight: '80%',
                  transform: 'scale(1)',
                  position: 'relative',
                  borderRadius: '6px',
                  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
                  border: '0 none',
                }}
              >
                {/* Header */}
                <div
                  className="modal-header px-3 py-2"
                  style={{
                    backgroundColor: '#e91e63',
                    border: 'none',
                    borderRadius: '6px 6px 0 0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexShrink: 0,
                    minHeight: 'unset', // removes Bootstrap's default minHeight
                  }}
                >
                  {/* Title */}
                  <h5
                    className="modal-title"
                    style={{
                      color: '#fff',
                      fontWeight: 700,
                      fontSize: '1.25rem',
                    }}
                  >
                    OTP Sent Successfully
                  </h5>

                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setOtpDialog(false)}
                    aria-label="Close"
                  />
                </div>

                {/* Body — text styles */}
                <div
                  className="modal-body text-center px-4 py-4"
                  style={{
                    overflowY: 'auto',
                    flexGrow: 1,
                  }}
                >
                  <p
                    className="mb-4"
                    style={{
                      fontSize: '15px',
                      color: '#495057',
                      lineHeight: '28px',
                      fontWeight: 400,
                    }}
                  >
                    <b>{otpMsg}</b>
                  </p>

                  <button
                    type="button"
                    className="btn"
                    onClick={handleOtpSuccessOk}
                    style={{
                      backgroundColor: '#f0ad4e',
                      color: '#fff',
                      width: '60px',
                      height: '42px',
                      fontSize: '16px',
                      fontWeight: 500,
                      border: 'none',
                      borderRadius: '5px',
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {otpSubmissionDialog && (
        <>
          <div className="modal-backdrop fade show" style={{ zIndex: 9999 }} />

          <div className="modal fade show d-block" style={{ zIndex: 10000 }}>
            <div
              className="modal-dialog modal-dialog-centered"
              style={{ maxWidth: '1040px' }}
            >
              <div className="modal-content border-0 shadow">
                {/* Header */}
                <div
                  className="modal-header"
                  style={{
                    background: '#e91e63',
                    color: '#fff',
                    borderBottom: 'none',
                    padding: '10px 16px', // reduced
                    minHeight: '48px', // reduced
                  }}
                >
                  <h5
                    className="modal-title fw-bold mb-0"
                    style={{
                      color: '#fff',
                      fontSize: '20px',
                      lineHeight: '1.2',
                    }}
                  >
                    OTP Submission
                  </h5>
                </div>

                {/* Body */}
                <div
                  className="modal-body"
                  style={{
                    padding: '35px 30px',
                  }}
                >
                  <div className="row justify-content-center align-items-end">
                    <div className="col-md-4">
                      <label
                        className="form-label fw-medium mb-1"
                        style={{ fontSize: '14px' }}
                      >
                        OTP <span className="text-danger">*</span>
                      </label>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter the OTP"
                        value={otpValue}
                        maxLength={6}
                        inputMode="numeric"
                        onKeyDown={numberOnly}
                        onChange={(e) =>
                          setOtpValue(
                            e.target.value.replace(/\D/g, '').slice(0, 6)
                          )
                        }
                        style={{
                          height: '40px',
                        }}
                      />
                    </div>

                    <div className="col-md-auto">
                      <button
                        className="btn px-4"
                        onClick={handleOtpSubmit}
                        style={{
                          backgroundColor: '#22C55E',
                          border: '1px solid #22C55E',
                          color: '#fff',
                          fontWeight: 600,
                        }}
                      >
                        Submit OTP
                      </button>
                    </div>
                  </div>

                  <div className="text-end mt-3">
                    <button
                      className="btn"
                      onClick={() => {
                        setShowResetPasswordDialog(false);

                        // Clear old values
                        setOtpValue('');
                        setNewPassValue('');
                        setConfirmPassValue('');
                        setPasswordTouched(false);
                        setValidation(true);

                        // Close OTP dialog also
                        setOtpSubmissionDialog(false);
                      }}
                      style={{
                        color: '#fff',
                        background: '#3B82F6',
                        border: '1px solid #3B82F6',
                        padding: '8px 18px',
                        fontSize: '14px',
                        borderRadius: '6px',
                        fontWeight: 700,
                      }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {showResetPasswordDialog && (
        <>
          <div className="modal-backdrop fade show" style={{ zIndex: 9999 }} />

          <div className="modal fade show d-block" style={{ zIndex: 10000 }}>
            <div
              className="modal-dialog modal-dialog-centered"
              style={{ maxWidth: '1000px' }}
            >
              <div className="modal-content border-0 shadow">
                {/* Header */}
                <div
                  className="modal-header"
                  style={{
                    background: '#e91e63',
                    borderBottom: 'none',
                    padding: '10px 16px',
                  }}
                >
                  <h5 className="modal-title fw-bold text-white mb-0">
                    OTP Submission
                  </h5>
                </div>

                {/* Body */}
                <div className="modal-body py-4 px-4">
                  <div className="row justify-content-center">
                    <div className="col-md-6">
                      <label className="form-label">
                        New Password
                        <span className="text-danger"> *</span>
                      </label>

                      <div className="position-relative">
                        <input
                          type={showNewPassword ? 'text' : 'password'}
                          className="form-control"
                          placeholder="Enter the new password"
                          value={newPassValue}
                          maxLength={15}
                          autoComplete="new-password"
                          onChange={(e) => setNewPassValue(e.target.value)}
                        />

                        <i
                          className={
                            showNewPassword ? 'pi pi-eye-slash' : 'pi pi-eye'
                          }
                          onClick={() => setShowNewPassword(!showNewPassword)}
                          style={{
                            position: 'absolute',
                            right: '12px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            zIndex: 1,
                          }}
                        />
                      </div>

                      <label className="form-label mt-3">
                        Confirm Password
                        <span className="text-danger"> *</span>
                      </label>

                      <div className="position-relative">
                        <input
                          type={showConfirmPassword ? 'text' : 'password'}
                          className="form-control"
                          placeholder="Confirm password"
                          value={confirmPassValue}
                          maxLength={15}
                          autoComplete="new-password"
                          onChange={(e) => setConfirmPassValue(e.target.value)}
                        />

                        <i
                          className={
                            showConfirmPassword
                              ? 'pi pi-eye-slash'
                              : 'pi pi-eye'
                          }
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                          style={{
                            position: 'absolute',
                            right: '12px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            zIndex: 1,
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mt-4">
                    <strong>Note:</strong> Password must contain at least one
                    lowercase, one uppercase, one numeric, minimum 8 characters
                    and maximum 15 characters.
                  </div>

                  <div className="text-end mt-4">
                    <button
                      className="btn me-2"
                      onClick={handlePasswordSubmit}
                      style={{
                        backgroundColor: '#22C55E',
                        border: '1px solid #22C55E',
                        color: '#fff',
                      }}
                    >
                      Submit
                    </button>

                    <button
                      className="btn"
                      style={{
                        backgroundColor: '#3B82F6',
                        border: '1px solid #3B82F6',
                        color: '#fff',
                      }}
                      onClick={() => {
                        setShowResetPasswordDialog(false);

                        // Clear old values
                        setOtpValue('');
                        setNewPassValue('');
                        setConfirmPassValue('');
                        setPasswordTouched(false);
                        setValidation(true);

                        // Close OTP dialog also
                        setOtpSubmissionDialog(false);
                      }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
